import { useTheme } from "next-themes";
import React, { useEffect, useState } from "react";

export default function RTHMDirectLogo({
    className,
    fillColor,
    link = "/",
}: {
    className?: string;
    fillColor?: string;
    link?: string;
}) {
    const { theme, resolvedTheme } = useTheme();
    const [mounted, setMounted] = useState(false);

    // Use useEffect to handle client-side mounting
    useEffect(() => {
        setMounted(true);
    }, []);

    // Default colors for light and dark modes
    const lightModeColor = "#1A5B77"; // Original blue color
    const darkModeColor = "#4FA3BD"; // Lighter blue for dark mode

    // During SSR and initial render, always use a consistent color (light mode)
    // Only after mounting on client, use the actual theme
    const logoColor =
        fillColor ||
        (mounted && (resolvedTheme === "dark" || theme === "dark")
            ? darkModeColor
            : lightModeColor);

    return (
        <a href={link} className="main-logo" aria-label="Logo link">
            <svg
                width="80"
                height="27"
                viewBox="0 0 80 27"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className={`${className}`}
            >
                <path
                    d="M24.943 19.9015V24.0449C23.8329 24.6901 22.5492 25.0977 20.7799 25.0977C17.5535 25.0977 15.3678 23.8411 15.3678 19.6298V11.0036H10.6553C8.20192 11.0036 5.2733 13.7205 5.2733 18.0676V24.792H0V6.58856H5.2733V10.2564C6.32103 7.80811 7.76813 6.64906 12.7446 6.59087C14.0298 6.45572 15.1816 5.70409 15.3678 4.50081V0H20.6411V4.48419C20.4914 5.78595 19.5415 6.42328 19.0466 6.58531H20.6411V6.58856H25.0124V11.0036H20.6411V18.7808C20.6411 19.9695 21.1615 20.5468 22.3411 20.5468C23.3125 20.5468 24.1798 20.3091 24.943 19.9015Z"
                    fill={logoColor}
                />
                <path
                    d="M44.6244 24.792V13.0073C44.6244 8.83003 42.2999 6.24895 38.3103 6.24895C35.6389 6.24895 34.0778 7.64138 32.8635 9.16965V0H27.5902V24.792H32.8635V14.6375C32.8635 12.1922 34.1471 10.9357 36.1593 10.9357C38.1715 10.9357 39.3511 12.1922 39.3511 14.6375V24.792H44.6244Z"
                    fill={logoColor}
                />
                <path
                    d="M70.4375 19.6282L70.4248 19.6302C70.4248 23.8415 72.6104 25.0981 75.8368 25.0981C77.6062 25.0981 78.8898 24.6905 80 24.0453V19.9019C79.2367 20.3095 78.3694 20.5472 77.398 20.5472C76.3244 20.5472 75.7969 20.0689 75.7108 19.0867V12.9394C75.7108 8.55834 73.3517 6.24895 69.4314 6.24895C66.8988 6.24895 64.956 7.2678 63.3254 9.13569C62.354 7.30176 60.5153 6.24895 58.0868 6.24895C55.4155 6.24895 53.8196 7.64138 52.6054 9.16965V6.58856H47.3321V24.792H52.6054V14.6375C52.6054 12.1922 53.8196 10.9357 55.7971 10.9357C57.7746 10.9357 58.8848 12.1922 58.8848 14.6375V24.792H64.1581V14.6375C64.1581 12.1922 65.3723 10.9357 67.3498 10.9357C69.3273 10.9357 70.4375 12.1922 70.4375 14.6375V19.6282Z"
                    fill={logoColor}
                />
            </svg>
        </a>
    );
}
